import React from 'react';

import { Cat, Dog, Puppy } from '@rover/icons';
import { Box } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import { PetType } from '@rover/types/src/Pet';

type Props = {
  petType: PetType;
};

const iconMap: Record<
  PetType,
  React.ComponentType<{ width: number; height: number; fill?: string }>
> = {
  [PetType.DOG]: Dog,
  [PetType.CAT]: Cat,
  [PetType.PUPPY]: Puppy,
};

const PetTypeIcon = ({ petType }: Props): JSX.Element => {
  const theme = useTheme();
  const Icon = iconMap[petType];

  return (
    <Box
      width="32px"
      height="32px"
      borderRadius="round"
      backgroundColor="yellow.200"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon width={24} height={24} fill={theme.colors.yellow[700]} />
    </Box>
  );
};

export default PetTypeIcon;
